export function extractDetailsFromCslp(cslpValue: string) {
	const [contentTypeUid, entryUid, locale, ...fieldPath] = cslpValue.split('.')

	if (Number.isFinite(+fieldPath[fieldPath.length - 1])) {
		fieldPath.pop()
	}

	return {
		entryUid,
		contentTypeUid,
		locale,
		fieldPathWithIndex: fieldPath.join('.'),
	}
}
